import { readinessIssue } from "./readinessIssue";
import type { RecordValue, Unit } from "./types";

export type PublicationAncestor = { unitId: string; name: string; unitKind: "COMPETITION" | "STAGE"; version: number };
export type AncestorReview = { payload: string; ancestors: PublicationAncestor[] };

/** Only a complete, current server plan can turn missing parents into a confirmation action. */
export function publicationAncestors(data: RecordValue, unit: Unit | null): PublicationAncestor[] {
  if (!unit || !["STAGE", "VOTING_ROUND"].includes(unit.unitKind) || data.canPublishAncestors !== true ||
    data.checkedVersion !== unit.version || !Array.isArray(data.issues) || !Array.isArray(data.publicationAncestors) ||
    data.publicationAncestors.length < 1 || data.publicationAncestors.length > 2) return [];
  const parents: PublicationAncestor[] = [];
  for (const value of data.publicationAncestors) {
    if (!value || typeof value !== "object" || Array.isArray(value) ||
      typeof value.unitId !== "string" || !/^[A-Za-z0-9][A-Za-z0-9_.-]{0,95}$/.test(value.unitId) || value.unitId === unit.unitId ||
      typeof value.name !== "string" || !value.name.trim() || value.name.length > 200 ||
      !["COMPETITION", "STAGE"].includes(String(value.unitKind)) || !Number.isSafeInteger(value.version) || Number(value.version) < 0) return [];
    parents.push({ unitId: value.unitId, name: value.name, unitKind: value.unitKind as PublicationAncestor["unitKind"], version: Number(value.version) });
  }
  if (new Set(parents.map(parent => parent.unitId)).size !== parents.length ||
    (parents.length === 2 && (parents[0].unitKind !== "COMPETITION" || parents[1].unitKind !== "STAGE")) ||
    (unit.unitKind === "STAGE" && (parents.length !== 1 || parents[0].unitKind !== "COMPETITION"))) return [];
  const issues = data.issues.map(issue => typeof issue === "string" ? readinessIssue(issue) : null);
  return issues.length === parents.length && issues.every((issue, index) => issue?.code === "EVENT_ANCESTOR_PUBLICATION_REQUIRED" && issue.unitId === parents[index].unitId)
    ? parents : [];
}
